var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isObject } from 'formik';
var unset = function (obj, path) {
    var keys = Array.isArray(path) ? path : path.split('.');
    var currentObj = obj;
    for (var i = 0; i < keys.length - 1; i++) {
        var key = keys[i];
        if (isObject(currentObj) && key in currentObj) {
            currentObj = currentObj[key];
        }
        else {
            return;
        }
    }
    var lastKey = keys[keys.length - 1];
    if (isObject(currentObj) && lastKey in currentObj) {
        delete currentObj[lastKey];
    }
};
export var deleteIn = function (obj, path) {
    // Convert path to an array if it's not already
    var keys = Array.isArray(path) ? path : path.split('.');
    // Shallow copy of the object
    var res = __assign({}, obj);
    // Navigate through the object to reach the target property
    var currentObj = res;
    for (var i = 0; i < keys.length - 1; i++) {
        var key = keys[i];
        // If the current key points to an object, create a shallow copy
        if (isObject(currentObj[key])) {
            currentObj[key] = __assign({}, currentObj[key]);
        }
        else {
            // If the key does not point to an object, exit the loop
            // as we cannot proceed further
            return res;
        }
        // Move to the next level in the object
        currentObj = currentObj[key];
    }
    // Delete the target property from the shallow-copied object
    unset(currentObj, keys[keys.length - 1]);
    return res;
};
/**
 * Function to check whether there are any non-null and non-undefined leaf nodes present in an object.
 */
export var isLeafNodePresent = function (obj) {
    for (var key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var value = obj[key];
            if (isObject(value) || Array.isArray(isObject)) {
                var isPresent = isLeafNodePresent(value);
                if (isPresent) {
                    return isPresent;
                }
            }
            else if (value !== undefined && value !== null) {
                return true;
            }
        }
    }
    return false;
};
